"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedFile = exports.isPdfFile = exports.isTbxConvertible = exports.isSwitchFile = exports.allowedFileExtensions = exports.tbxConvertibleFileExtensions = exports.switchFileExtensions = exports.allowedFileTypes = exports.pdfFileTypes = exports.tbxConvertibleFileTypes = exports.switchFileTypes = exports.illustratorFileTypes = exports.indesignFileTypes = exports.photoshopFileTypes = void 0;
exports.photoshopFileTypes = [
    'image/vnd.adobe.photoshop',
    'application/x-photoshop',
    'application/photoshop',
    'application/psd',
    'image/psd'
];
exports.indesignFileTypes = ['application/x-indesign'];
exports.illustratorFileTypes = [
    'application/illustrator',
    'application/postscript'
];
exports.switchFileTypes = [
    ...exports.photoshopFileTypes,
    ...exports.indesignFileTypes,
    ...exports.illustratorFileTypes
];
exports.tbxConvertibleFileTypes = [
    'image/jpeg',
    'image/png',
    'image/tiff'
];
exports.pdfFileTypes = ['application/pdf'];
exports.allowedFileTypes = Array.from(new Set([
    ...exports.tbxConvertibleFileTypes,
    ...exports.pdfFileTypes,
    ...exports.switchFileTypes
]).values());
exports.switchFileExtensions = ['ai', 'psd'];
exports.tbxConvertibleFileExtensions = [];
exports.allowedFileExtensions = Array.from(new Set([...exports.switchFileExtensions, ...exports.tbxConvertibleFileExtensions]).values());
function isSwitchFile({ mime, ext }) {
    return (exports.switchFileTypes.includes(mime) ||
        exports.switchFileExtensions.includes(ext.replace('.', '').toLowerCase()));
}
exports.isSwitchFile = isSwitchFile;
function isTbxConvertible({ mime, ext }) {
    return (exports.tbxConvertibleFileTypes.includes(mime) ||
        exports.tbxConvertibleFileExtensions.includes(ext.replace('.', '').toLowerCase()));
}
exports.isTbxConvertible = isTbxConvertible;
function isPdfFile({ mime, ext }) {
    return (exports.pdfFileTypes.includes(mime) || ext.replace('.', '').toLowerCase() === 'pdf');
}
exports.isPdfFile = isPdfFile;
function isSupportedFile(type) {
    return isPdfFile(type) || isSwitchFile(type) || isTbxConvertible(type);
}
exports.isSupportedFile = isSupportedFile;
//# sourceMappingURL=fileTypes.js.map